














































import Vue from 'vue'
import Lottie from 'vue-lottie'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {sleep} from '@/utils/async'

@Component<ScorecardSubpage>({
    components: {Lottie}
})
export default class ScorecardSubpage extends Vue {
    public animationData ?: any = null

    @Prop({type: String, default: ''}) public badgeId !: string
    @Prop({type: Boolean, default: false}) public sticky !: string
    @Prop({type: Boolean, default: true}) public showHeader !: boolean
    @Prop({type: Boolean, default: true}) public showBack !: boolean
    @Prop({type: String, default: ''}) public buttonRight !: string
    @Prop({type: String, default: ''}) public title !: string
    @Prop({type: String, default: '#F4F6FC'}) public bgColor !: string
    @Prop({type: String, default: 'left'}) public slide!: string

    @Action public setSlide

    @Getter
    $isMobile

    private routerStack: Array<any> = []

    public slideName = `slide-${this.slide}`

    public async mounted() {
        if (this.badgeId) {
            this.animationData = (await import(`@/assets/img/scorecard/animated/${this.badgeId}.json`)).default
        }
    }

    @Watch('slide')
    public updateSlide() {
        this.slideName = `slide-${this.slide}`
    }

    //This gets around certain limitations with watched properties and variables not updating.
    @Watch('$route', { immediate: true, deep: true })
    public onRouterUpdate() {
        this.routerStack = (this.$router as any).history.stack
    }

    get historyStack() {
        //Router will always have history, but it's set as private for some reason.
        //Retyping as any gets around the linting error.
        //Slice up to the current page.
        const currentIndex = this.routerStack.findIndex((r) => r.path === this.$route.path)
        return this.routerStack.slice(0, currentIndex).reverse()
    }

    public async goBack() {
        // set back page slide right in
        this.setSlide('right') // new page slide right in
        await sleep(10)
        this.slideName = 'slide-left' // we slide left out

        if (this.$isMobile) {
            this.$router.back()
        } else {
            const lastRoute = this.historyStack.shift()
            this.$router.push({ name: lastRoute.name, params: lastRoute.params })
        }
    }

    public get isBlackArrow() {
        if (this.badgeId === 'unknown-badge') {
            return true
        }
        return !this.animationData
    }
}
